import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const MenuIdContext = createContext("unknown");
function MenuIdProvider({ menuId, children }) {
  return /* @__PURE__ */ jsx(MenuIdContext.Provider, { value: menuId, children });
}
function useMenuId() {
  return useContext(MenuIdContext);
}
export {
  MenuIdProvider,
  useMenuId
};
//# sourceMappingURL=useMenuId.js.map
